import clsx from "clsx";
import { Icon, type IconProps } from "@/ui/icon/Icon";
import styles from "./RadioIcon.module.css";

interface RadioIconProps extends Omit<IconProps, "name"> {
  active?: boolean;
  highlight?: boolean;
  disabled?: boolean;
}

export const RadioIcon: React.FC<RadioIconProps> = ({
  active,
  highlight,
  disabled,
  className,
  ...props
}) => {
  return (
    <Icon
      className={clsx(
        styles.radio,
        [
          active === true && styles.active,
          highlight === true && styles.highlight,
          disabled === true && styles.disabled,
        ],
        className,
      )}
      name="radio_button_24px"
      {...props}
    />
  );
};
